import React from 'react';
import PropTypes from 'prop-types';

class InContainer extends React.Component {
    getContainerClass() {
        if (this.props.margined) {
            return 'margined container';
        }
        return 'container';
    }

    render() {
        return (
            <div className={this.getContainerClass()}>
                {this.props.children}
            </div>
        );
    }
}

InContainer.propTypes = {
    margined: PropTypes.bool
};

InContainer.defaultProps = {
    margined: true
};

export default InContainer;
